export default "__VITE_ASSET__JViUKOAu__"